module.exports = __webpack_public_path__ + "assets/img/ehoiLogo.91b6591d.svg";